module.exports = __webpack_public_path__ + "img/footerLogo.05bb2ca5.jpg";